import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewImportaComprobante = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'importa_comprobante',
        name: 'importa_comprobante',
        component: ViewImportaComprobante,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]
export default router
